import jsCookie from 'js-cookie';
import guid from './guid';

const PREFIX = '_bgh_';
const anonIdCookieName = `${PREFIX}anon_id`;
const userIdCookieName = `${PREFIX}user_id`;

const getCookieNamesForAction = action => ({
  timestamp: `${PREFIX}${action.toLowerCase()}`,
  data: `${PREFIX}${action.toLowerCase()}_data`,
});

export const storeAnonId = () => {
  return jsCookie.set(anonIdCookieName, guid());
};

export const retrieveAnonId = () => {
  return jsCookie.get(anonIdCookieName);
};

export const save = (action, data = {}) => {
  const cookieNames = getCookieNamesForAction(action);

  jsCookie.set(cookieNames.timestamp, new Date().getTime().toString());
  jsCookie.set(cookieNames.data, data);

  if (data.userId) jsCookie.set(userIdCookieName, data.userId);
};

export const retrieve = action => {
  const cookieNames = getCookieNamesForAction(action);

  return {
    timestamp: jsCookie.get(cookieNames.timestamp),
    data: jsCookie.get(cookieNames.data),
  };
};

export const retrieveUserId = () => {
  const id = jsCookie.get(userIdCookieName);
  return id ? parseInt(id, 10) : null;
};

export const remove = action => {
  const cookieNames = getCookieNamesForAction(action);

  jsCookie.remove(cookieNames.timestamp);
  jsCookie.remove(cookieNames.data);
};
